import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertMobilityVehicleMutationVariables = Types.Exact<{
  object: Types.Mobility_Vehicles_Insert_Input;
}>;


export type InsertMobilityVehicleMutation = { __typename?: 'mutation_root', insert_mobility_vehicles_one?: { __typename?: 'mobility_vehicles', id: number, customer_id: number, make: string, model: string, year?: number | null, color?: string | null, license_plate?: string | null, vin?: string | null, capacity?: number | null, status: string, created_at: string, updated_at: string } | null };


export const InsertMobilityVehicleDocument = gql`
    mutation InsertMobilityVehicle($object: mobility_vehicles_insert_input!) {
  insert_mobility_vehicles_one(object: $object) {
    id
    customer_id
    make
    model
    year
    color
    license_plate
    vin
    capacity
    status
    created_at
    updated_at
  }
}
    `;
export type InsertMobilityVehicleMutationFn = Apollo.MutationFunction<InsertMobilityVehicleMutation, InsertMobilityVehicleMutationVariables>;

/**
 * __useInsertMobilityVehicleMutation__
 *
 * To run a mutation, you first call `useInsertMobilityVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertMobilityVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertMobilityVehicleMutation, { data, loading, error }] = useInsertMobilityVehicleMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertMobilityVehicleMutation(baseOptions?: Apollo.MutationHookOptions<InsertMobilityVehicleMutation, InsertMobilityVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertMobilityVehicleMutation, InsertMobilityVehicleMutationVariables>(InsertMobilityVehicleDocument, options);
      }
export type InsertMobilityVehicleMutationHookResult = ReturnType<typeof useInsertMobilityVehicleMutation>;
export type InsertMobilityVehicleMutationResult = Apollo.MutationResult<InsertMobilityVehicleMutation>;
export type InsertMobilityVehicleMutationOptions = Apollo.BaseMutationOptions<InsertMobilityVehicleMutation, InsertMobilityVehicleMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobilityVehicles/queries/insertMobilityVehicle.mutation.gql}
 */
export async function insertMobilityVehicle(
  variables: InsertMobilityVehicleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertMobilityVehicleMutation['insert_mobility_vehicles_one']>
export async function insertMobilityVehicle(
  variables: InsertMobilityVehicleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertMobilityVehicleMutation>
export async function insertMobilityVehicle(
  variables: InsertMobilityVehicleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertMobilityVehicleMutation['insert_mobility_vehicles_one'] | InsertMobilityVehicleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertMobilityVehicleMutation>(
    InsertMobilityVehicleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_mobility_vehicles_one
}